<template>
    <div>
        <sub-menu-faturamento ativo="faturas"></sub-menu-faturamento>

        <div v-if="!fatura">

            <div class="card dashcard mb-0">
                <div class="card-body">
                    <div class="form-row mb-2">
                        <div class="col col-md-6">
                            <az-periodo v-model="filtros" :sync="true" @sync="load(true, 1)" />
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-input 
                                icon="fa fa-calendar-o fa-fw"
                                type="select"
                                placeholder="Emissão da Fatura"
                                :optionsList="[
                                    { id: 'e', search: 'Envio da Fatura' },
                                    { id: 'v', search: 'Vencimento da Fatura' },
                                ]"
                                optionsDisplay="search"
                                optionsData="id"
                                v-model="filtros.referencia">
                            </az-input>
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-input
                                icon="fa fa-filter"
                                type="select"
                                service="status-guia.index"
                                optionsMode="json"
                                optionsData="id"
                                optionsDisplay="display"
                                :optionsList="statusList"
                                placeholder="Todas..."
                                v-model="filtros.status">
                            </az-input>
                        </div>
                        <div class="col col-12 col-md-2">
                            <az-input   
                                type="select"
                                placeholder="Todas..."
                                icon="fa fa-filter"
                                optionsMode="json"
                                :optionsList="[
                                    { id: 'F', search: 'Faturas' },
                                    { id: 'R', search: 'Recursos de Glosa' },
                                ]" 
                                optionsData="id"
                                v-model="filtros.tipo" />
                        </div>
                    </div>

                    <div class="form-row mb-2">
                        <div class="col col-12 col-md-2">
                            <az-input
                                :edicao="!$store.state.user.id_unidade_operacao"
                                icon="fa fa-building fa-fw"
                                type="select"
                                placeholder="Todas as Unidades..."
                                :optionsList="$util.unidades_com_tags(true, true)"
                                optionsData="id_unidade_operacao"
                                v-model="filtros.id_unidade_operacao">
                            </az-input>

                            <div class="input-group mb-1" v-if="false">
                                <div class="input-group-prepend">
                                    <span class="input-group-text" id="basic-addon1">
                                        <i class="fa fa-building fa-fw" :class="filtros.id_unidade_operacao ? 'text-success' : ''" aria-hidden="true"></i>
                                    </span>
                                </div>
                                <select class="form form-control" v-model="filtros.id_unidade_operacao"
                                    :disabled="$store.state.user.id_unidade_operacao > 0">
                                    <option value="">Todas as Unidades...</option>
                                    <option v-for="(und, iux) in $util.unidades_com_tags(false, true)" 
                                        :value="und.id_unidade_operacao" :key="iux">{{ und.search }}</option>
                                </select>
                            </div>
                        </div>

                        <div class="col col-12 col-md-2">
                            <i class="" aria-hidden="true"></i>
                            <az-input   
                                placeholder="Todos os Médicos..."
                                icon="fa fa-user-md"
                                :hli="true"

                                type="autocomplete" 
                                optionsMode="aql"
                                service="medicos.index"
                                optionsDisplay="search"
      
                                optionsData="id_pessoa"
                                v-model="filtros.id_medico" />

                            <!-- optionsMode="json"
                                :optionsList="[
                                    { id: 'F', search: 'Faturas' },
                                    { id: 'R', search: 'Recursos de Glosa' },
                                ]"  -->
                        </div>

                        <div class="col col-12 col-md-2">
                            <az-input
                                :hli="true"
                                icon="far fa-credit-card"
                                type="select" 
                                optionsMode="aql"
                                optionsData="id_operadora"
                                optionsDisplay="st_operadora"
                                :optionsParm="{ 
                                    fatura: true,
                                    classes: true,
                                    lista: true, 
                                }"
                                service="operadoras.index"
                                optionsName="operadoras-para-fatura-2"
                                placeholder="Todas Operadoras..."
                                v-model="filtros.id_operadora">
                            </az-input>
                        </div>

                        <div class="col col-12 col-md-2">
                            <az-input
                                :hli="true"
                                icon="fas fa-file-contract"
                                type="autocomplete" 
                                optionsMode="aql"
                                optionsData="id_contrato_operadora"
                                optionsDisplay="search"
                                service="contrato_operadoras.index"
                                :optionsParm="{ id_operadora: filtros.id_operadora, guias: true }"
                                optionsName="contratos-busca-guia"
                                placeholder="Contrato..."
                                :edicao="filtros.id_operadora ? true : false"
                                v-model="filtros.id_contrato_operadora">
                            </az-input>
                        </div>

                        <div class="col col-12 col-md-2">
                            <az-input
                                icon="fas fa-file-powerpoint"
                                type="autocomplete" 
                                optionsMode="aql"
                                optionsData="id_plano"
                                optionsDisplay="st_plano"
                                service="planos.index"
                                :optionsParm="{ id_operadora: filtros.id_operadora }"
                                :edicao="filtros.id_operadora ? true : false"
                                optionsName="planos"
                                placeholder="Plano..."
                                v-model="filtros.id_plano">
                            </az-input>
                        </div>

                        <div class="col col-12 col-md-2">
                            <az-input   
                                type="select"
                                placeholder="Todas os Contratos..."
                                icon="fa fa-filter"
                                :hli="true"
                                optionsMode="json"
                                :optionsList="[
                                    { id: 'PJ', search: 'Contratos PJ' },
                                    { id: 'PF', search: 'Contratos PF' },
                                ]" 
                                optionsData="id"
                                v-model="filtros.tipo_contrato" />
                        </div>
                    </div>
                    
                    <div class="form-row">
                        <div class="col col-12 col-md-9">
                            <az-input
                                :hli="true"
                                icon="fa fa-search fa-fw"
                                type="text"
                                :shortkey="['ctrl', 'p']"
                                placeholder="Pesquisar por (ou digite # + número da fatura, ou P + número do protocolo)..."
                                v-model="pesquisar"
                                @onEnter="load()">
                                <template v-slot:buttonposb>
                                    <print-export printid="lista-faturas" :dados="dadosFormatados" :left="true" />
                                </template>
                            </az-input>
                        </div>

                        <div class="col col-12 col-md-3">
                            <az-input
                                icon="fa-solid fa-comments fa-fw"
                                type="select"
                                placeholder="Status de Fluxo..."
                                optionsMode="aql"
                                service="contato_status.index"
                                :optionsParm="{ model: 'fatura', ativos: true }"
                                optionsName="cont_status_fluxo_fatura"
                                optionsData="id_contato_status"
                                v-model="filtros.id_contato_status" />
                        </div>

                    </div>
                </div>
            </div>

            <div class="progress mt-1 mb-2">
                <div class="indeterminate" v-if="$store.state.loading && faturas && faturas.data.length"></div>
                <div class="determinate" v-else></div>
            </div>

            <div v-if="faturas && faturas.data.length">

                <small v-if="faturas.last_page > 1">
                    <span v-if="faturas.last_page > 1">{{ faturas.from }} - {{ faturas.to }} / </span>
                    <span>{{ faturas.total }} {{ faturas.total == 1 ? 'fatura' : 'faturas' }}</span>
                </small>

                <div id="lista-faturas">

                <table class="table table-hover table-sm table-responsive-md bg-white w3-animate-opacity cabecalho-fixo">
                    <thead>
                        <tr>
                            <td colspan="100" class="p-0">
                                <div class="d-none d-print-block">
                                    <cabecalho-generico titulo="Faturas">
                                    </cabecalho-generico>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <th></th>
                            <table-th title="Data" v-model="ordem" sortby="dt_emissao"></table-th>
                            <table-th title="Vencimento" v-model="ordem" sortby="fatura_envio.dt_vencimento"></table-th>
                            <table-th title="Fatura" v-model="ordem" sortby="id_fatura"></table-th>
                            <template v-if="filtros.status != 'CA' && filtros.status != 'FA' && filtros.status != 'FP'">
                                <table-th title="Protocolo" v-model="ordem" sortby="fatura_envio.st_protocolo_entrega"></table-th>
                                <table-th title="NF" v-model="ordem" sortby="fatura_envio.st_nota_fiscal"></table-th>
                            </template>
                            <table-th title="Operadora" v-model="ordem" sortby="operadora.st_operadora"></table-th>
                            <th class="text-right">Valor</th>
                            <th class="text-right">Glosado</th>
                            <th class="text-right">Recebido</th>
                            <th class="text-right">A Receber</th>
                            <td class="text-center">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" v-model="selectAll" id="defaultCheck1"
                                        @change="onSelectAll ()">
                                </div>
                            </td>
                        </tr>
                    </thead>

                    <tr class="table-primary">
                        <td></td>
                        <td colspan="3">Total</td>
                        <template v-if="filtros.status != 'CA' && filtros.status != 'FA' && filtros.status != 'FP'">
                            <td colspan="2"></td>
                        </template>
                        <td>{{ exibicao.length }} {{ exibicao.length > 1 ? 'faturas' : 'fatura' }}</td>
                        <td class="text-right">{{ $util.formatMoeda(valor_total.total) }}</td>
                        <template v-if="filtros.status != 'CA'">
                            <td class="text-right text-danger">{{ $util.formatMoeda(valor_total.glosado) }}</td>
                            <td class="text-right text-primary">
                                {{ $util.formatMoeda(valor_total.recebido) }}
                                <div v-if="valor_total.a_mais > 0" title="Recebimento a mais." class="small text-muted">
                                    <i class="fa-solid fa-circle-plus mr-1"></i>
                                    {{ $util.formatMoeda(valor_total.a_mais) }}
                                </div>
                            </td>
                            <td class="text-right text-success">{{ $util.formatMoeda(valor_total.a_receber) }}</td>
                        </template>
                        <td></td>
                    </tr>
                    <tr class="table-info">
                        <td></td>
                        <td colspan="3">Selecionado</td>
                        <template v-if="filtros.status != 'CA' && filtros.status != 'FA' && filtros.status != 'FP'">
                            <td colspan="2"></td>
                        </template>
                        <td>{{ selecteds.length }} {{ selecteds.length > 1 ? 'faturas' : 'fatura' }}</td>
                        <td class="text-right">{{ $util.formatMoeda(valor_selecionado.total) }}</td>
                        <template v-if="filtros.status != 'CA'">
                            <td class="text-right text-danger">{{ $util.formatMoeda(valor_selecionado.glosado) }}</td>
                            <td class="text-right text-primary">
                                {{ $util.formatMoeda(valor_selecionado.recebido) }}
                                <div v-if="valor_selecionado.a_mais > 0" title="Recebimento a mais." class="small text-muted">
                                    <i class="fa-solid fa-circle-plus mr-1"></i>
                                    {{ $util.formatMoeda(valor_selecionado.a_mais) }}
                                </div>
                            </td>
                            <td class="text-right text-success">{{ $util.formatMoeda(valor_selecionado.a_receber) }}</td>
                        </template>
                        <td></td>
                    </tr>
                    
                    <tbody>
                        <tr v-for="(item, index) in exibicao" :key="index" :class="item.selected ? 'table-secondary' : ''"
                            class="table-light">
                            <td>
                                <a href="#" @click.prevent="filtrar(item.ch_status)">
                                    <span class="badge" :class="'badge-' + item.status_color"
                                        data-toggle="tooltip" data-placement="top" :title="item.status">
                                        {{ item.ch_status }}
                                    </span>
                                </a>
                            </td>
                            <td>{{ getFormatDate (item.dt_emissao, 'DD/MM/YYYY') }}</td>
                            <td>
                                <span v-if="item.fatura_envio">
                                    {{ getFormatDate (item.fatura_envio.dt_vencimento, 'DD/MM/YYYY') }}
                                </span>
                            </td>
                            <td>
                                <a href="#" class="card-link" @click.prevent="exibirFatura(item)">
                                    {{ item.id_fatura }}
                                    <i class="fas fa-registered text-warning" v-if="item.fl_reapresentacao"
                                        data-toggle="tooltip" data-placement="top" title="Recurso de Glosa"></i>
                                </a>
                            </td>
                            <template v-if="filtros.status != 'CA' && filtros.status != 'FA' && filtros.status != 'FP'">
                                <td>
                                    <a href="#" @click.prevent="filtrar(item.fatura_envio.st_protocolo_entrega)" v-if="item.fatura_envio">
                                        <span class="small">{{ item.fatura_envio.st_protocolo_entrega }}</span>
                                    </a>
                                </td>
                                <td>
                                    <a href="#" @click.prevent="filtrar(item.fatura_envio.st_nota_fiscal)" v-if="item.fatura_envio">
                                        <span class="small">{{ item.fatura_envio.st_nota_fiscal }}</span>
                                    </a>

                                    <div v-if="item.fatura_creditos">
                                        <div v-for="(fc, ifc) in item.fatura_creditos" :key="ifc">
                                            <a href="#" @click.prevent="filtrar(fc.nota.numero_completo)" v-if="fc.nota">
                                                <span class="small">{{ fc.nota.numero_completo }}</span>
                                            </a>
                                        </div>
                                    </div>
                                </td>
                            </template>
                            <td>
                                <a href="#" @click.prevent="filtrar(item.operadora.st_operadora)">
                                    {{ item.operadora.st_operadora }}
                                </a>
                                <template v-if="item.contratos">
                                    <small class="text-muted mr-2">
                                        {{ lista_contratos(item) }}
                                    </small>
                                </template>
                                <small class="text-muted" v-if="item.ch_status == 'FA' && item.operadora.parametro_fatura && item.operadora.parametro_fatura.envio_titulo">
                                    envio {{ item.operadora.parametro_fatura.envio_titulo }}
                                </small>
                                <small class="text-muted text-nowrap" v-else-if="item.fatura_envio">
                                    <i class="fas fa-paper-plane ml-2"></i>
                                    {{ $util.getFormatDate(item.fatura_envio.dt_envio) }}
                                </small>

                                <div v-if="item.st_observacoes && exibir_fatura_obs" class="small text-muted">
                                    <i class="fa fa-comment mr-2" aria-hidden="true"></i>
                                    {{ item.st_observacoes }}
                                </div>

                                <div v-if="exibir_status_fluxo_fatura && item.status_contato && item.status_contato.contato_status">
                                    <span class="badge" :class="'badge-' + item.status_contato.contato_status.st_color">
                                        {{ item.status_contato.contato_status.st_contato_status }}
                                    </span>
                                </div>
                            </td>
                            <td class="text-right">{{ $util.formatMoeda(item.valor_total.total) }}</td>
                            <td class="text-right text-danger">{{ $util.formatMoeda(item.valor_total.glosado) }}</td>
                            <td class="text-right text-primary">
                                <span v-if="item.guia_faturas_sem_ident_count > 0" title="Recebimento sem crédito identificado.">
                                    <i class="fa-solid fa-circle-question text-warning"></i>
                                </span>
                                {{ $util.formatMoeda(item.valor_total.recebido) }}

                                <div v-if="item.valor_total.a_mais > 0" title="Recebimento a mais." class="small text-muted">
                                    <i class="fa-solid fa-circle-plus mr-1"></i>
                                    {{ $util.formatMoeda(item.valor_total.a_mais) }}
                                </div>
                            </td>
                            <td class="text-right text-success">
                                
                                {{ $util.formatMoeda(item.valor_total.a_receber) }}</td>
                            <td class="text-center">
                                <div class="form-check">
                                    <input class="form-check-input" type="checkbox" v-model="item.selected" id="defaultCheck1"
                                        @change="selectAll = false">
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>

                </div>

                <div class="form-row my-3">
                    <div class="col col-12 col-md-6">
                        <az-input 
                            type="checkbox-group"
                            sizing="sm"
                            label="Exibir Observações da Fatura"
                            v-model="exibir_fatura_obs" />
                    </div>

                    <div class="col col-12 col-md-6">
                        <az-input 
                            type="checkbox-group"
                            sizing="sm"
                            label="Exibir Status de Fluxo da Fatura"
                            v-model="exibir_status_fluxo_fatura" />
                    </div>
                </div>

            </div>

            <div v-else>
                <az-empty-state 
                    :icon="firstLoad ? 'fas fa-file-invoice-dollar' : 'fas fa-sync-alt'" 
                    :msg="firstLoad ? 'Nenhuma fatura encontrada.' : 'Clique no ícone para atualizar a busca.'"
                    :action="firstLoad ? '' : 'Buscar'"
                    :method="load"></az-empty-state>
            </div>

            <operadoras-a-enviar v-if="filtros.status == 'FA'" />

        </div>

        <div v-else>
            <guia-fatura ref="fatura_page" :fatura="fatura" :exibir="true" @fechar="fecharFatura ()" />
        </div>

        <!-- Modal -->
        <div class="modal fade" id="cancelarFaturasModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Cancelar Faturas Selecionadas</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <p class="alert alert-primary">Faturas: {{ selecteds.map(item => item.id_fatura) }}</p>

                        <az-input
                            label="Motivo de Cancelamento"
                            required 
                            :validate="validate"
                            v-model="motivo_cancelamento" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit color="danger" @click="cancelar_faturas()">Confirmar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="dtMovModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Recebimento</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <p class="lead">Confirma realizar o recebimento integral das faturas selecionadas?</p>

                        <az-input
                            label="Data do Recebimento"
                            type="date"
                            required
                            :validade="validate"
                            v-model="dt_retorno" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <az-submit @click="salvar_receber_faturas()">Receber</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <br><br><br><br>

        <!-- Paginação -->
        <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="!fatura && ( ( faturas && faturas.last_page > 1 ) || ( selected ) )">
            <div class="d-flex" v-if="( faturas && faturas.last_page > 1 )">
                <paginate
                    class="mb-0"
                    :page-count="faturas.last_page"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-link'"
                    :next-class="'page-link'"
                    :prev-text="'<<'"
                    :next-text="'>>'"
                    :click-handler="paginar">
                </paginate>
            </div>
            <a class="navbar-brand" href="#" v-else>Opções</a>
            
            <div class='mr-3' v-if="selected"> 

                <button class="btn btn-sm ml-1" type="button"
                    :class="desabilitar('mail') ? 'btn-outline-secondary' : 'btn-dark'"
                    data-toggle="tooltip" data-placement="top" title="Enviar e-mail"
                    :disabled="desabilitar('mail')" @click="enviar_email()">
                    <i class="fa-regular fa-envelope-open"></i>
                </button>

                <button class="btn btn-sm ml-1" type="button"
                    :class="podeEnviarBoleto ? 'btn-primary' : 'btn-outline-secondary'"
                    data-toggle="tooltip" data-placement="top" title="Enviar Boletos por Email"
                    :disabled="!podeEnviarBoleto" @click="enviar_boletos()">
                    <i class="fa-regular fa-barcode"></i>
                </button>

                <button class="btn btn-sm ml-1" type="button"
                    :class="desabilitar('receber') ? 'btn-outline-secondary' : 'btn-primary'"
                    data-toggle="tooltip" data-placement="top" title="Receber Fatura Integral"
                    :disabled="desabilitar('receber')" @click="receber_faturas()">
                    <i class="fas fa-donate"></i>
                </button>
                <button class="btn btn-sm ml-1" type="button"
                    :class="desabilitar('cancelar') ? 'btn-outline-secondary' : 'btn-danger'"
                    data-toggle="tooltip" data-placement="top" title="Cancelar Fatura"
                    :disabled="desabilitar('cancelar')" @click="abrir_cancelar_faturas()">
                    <i class="fas fa-times"></i>
                </button>
                <button class="btn btn-sm ml-1" type="button"
                    :class="desabilitar('mesclar') ? 'btn-outline-secondary' : 'btn-success'"
                    data-toggle="tooltip" data-placement="top" title="Mesclar Faturas"
                    :disabled="desabilitar('mesclar')"  @click="mesclar_faturas()">
                    <i class="fas fa-copy"></i>
                </button>
            </div>
        </nav>

        <nav class="navbar fixed-bottom navbar-light bg-light" v-if="false && selected">
            <a class="navbar-brand" href="#">Opções</a>
            <div class='mr-3'> 
                <button class="btn btn-sm ml-1" type="button"
                    :class="desabilitar('receber') ? 'btn-outline-secondary' : 'btn-primary'"
                    data-toggle="tooltip" data-placement="top" title="Receber Fatura Integral"
                    :disabled="desabilitar('receber')" @click="receber_faturas()">
                    <i class="fas fa-donate"></i>
                </button>
                <button class="btn btn-sm ml-1" type="button"
                    :class="desabilitar('cancelar') ? 'btn-outline-secondary' : 'btn-danger'"
                    data-toggle="tooltip" data-placement="top" title="Cancelar Fatura"
                    :disabled="desabilitar('cancelar')" @click="abrir_cancelar_faturas()">
                    <i class="fas fa-times"></i>
                </button>
                <button class="btn btn-sm ml-1" type="button"
                    :class="desabilitar('mesclar') ? 'btn-outline-secondary' : 'btn-success'"
                    data-toggle="tooltip" data-placement="top" title="Mesclar Faturas"
                    :disabled="desabilitar('mesclar')"  @click="mesclar_faturas()">
                    <i class="fas fa-copy"></i>
                </button>
            </div>
        </nav>

        <enviar-email-fatura ref="envio_email" />

    </div>
</template>

<script>
import SubMenuFaturamento from './SubMenuFaturamento.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzInput from '../../shared/forms/AzInput.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import GuiaFatura from './GuiaFatura.vue';
import * as moment from 'moment';
import _ from 'lodash';
import $ from 'jquery';
import TableTh from '../../shared/table/TableTh.vue';
import OperadorasAEnviar from './OperadorasAEnviar.vue';
import PrintExport from '../../shared/PrintExport.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import EnviarEmailFatura from './EnviarEmailFatura.vue';

export default {
    data () { 
        return { 
            faturas: null,
            fatura: null, 
            ordem: "", 
            exibir_fatura_obs: false, 
            exibir_status_fluxo_fatura: false, 
            filtros: {
                inicio: null,
                fim: null, 
                status: this.$util.getCookie('faturas-filtros-status') ? this.$util.getCookie('faturas-filtros-status') : 'FA',
                id_operadora:  "", 
                id_contrato_operadora: "", 
                id_unidade_operacao: "", 
                id_medico: "", 
                periodo: "",
                mes: "", 
                referencia: this.$util.getCookie('faturas-filtros-referencia') ? this.$util.getCookie('faturas-filtros-referencia') : "",
                tipo: this.$util.getCookie('faturas-filtros-tipo') ? this.$util.getCookie('faturas-filtros-tipo') : 'F',
                tipo_contrato: this.$util.getCookie('faturas-filtros-tipo-contrato') ? this.$util.getCookie('faturas-filtros-tipo-contrato') : '',
                id_contato_status: "", 
            },
            selectAll: false,
            statusList: [
                { id: 'TA', display: 'Todas Ativas' },
                { id: 'FA', display: 'Fatura a Enviar' },
                { id: 'FP', display: 'Fatura Aguardando Protocolo' },
                { id: 'FE', display: 'Fatura Enviada' },
                { id: 'FM', display: 'Fatura Movimentada' },
                { id: 'CA', display: 'Fatura Cancelada' },
            ],
            pesquisar: "",
            motivo_cancelamento: "", 
            validate: false, 
            canceltoken: null, 
            dt_retorno: null, 
            page: 1,
            firstLoad: false,
            podeEnviarBoleto: false
        }
    },

    props: ['id_fatura', 'id_operadora', 'origem'], 

    watch: { 
        filtros: {
            handler: function () {
                /*
                if ( ( this.filtros.inicio ? true : false ) ^ ( this.filtros.fim ? true : false ) ) 
                    return;

                this.load ();
                */
            },
            deep: true,
            immediate: true
        }
    },

    components: { 
        SubMenuFaturamento,
        AzEmptyState,
        AzInput,
        AzPeriodo, 
        GuiaFatura, 
        TableTh, 
        AzSubmit,
        OperadorasAEnviar, 
        PrintExport,
        CabecalhoGenerico, 
        EnviarEmailFatura, 
    },

    computed: { 
        exibicao: function () { 
            if ( !this.faturas )
                return [];
                
            let pesquisar = this.pesquisar;
            let parts = pesquisar.split(' ');
            let match = parts.reduce((total, item) => {
                if ( !item.trim() || isNaN(item) ) { 
                    return total;
                }

                return total + `.*${item}.*`;
            }, "" );
            let reg = new RegExp(match, 'i');
            let items;
            
            if ( pesquisar ) {
                items = this.faturas.data.filter (item => { 
                    return ( !this.pesquisar || reg.test(JSON.stringify(item)) )
                });
            } else { 
                items = this.faturas.data;
            }

            let ordem = this.ordem;

            if ( this.ordem ) { 
                items = _.sortBy(items, function (item) { 
                    return _.get(item, ordem.name );
                });

                if ( this.ordem.direction == 'desc' ) {
                    items = _.reverse(items); 
                }
            } 

            return items;          
        },
        selected () { 
            return this.exibicao.findIndex(item => { 
                            return item.selected;
                        }) >= 0 ;
        },
        selecteds () { 
            let items = this.exibicao.filter (item => { 
                return item.selected;
            });

            return items;
        },
        operadora_selected () { 
            return _.uniq(
                _.map(this.selecteds, (item) => { 
                    return item.operadora.id_operadora;
                })
            );
        },
        valor_total: function () {
            let init = { total: 0, glosado: 0, recebido: 0, a_receber: 0, a_mais: 0 };

            return this.exibicao.reduce((a, b) => { 
                return { 
                    total: a.total + parseFloat(b.valor_total.total),
                    glosado: a.glosado + parseFloat(b.valor_total.glosado),
                    recebido: a.recebido + parseFloat(b.valor_total.recebido),
                    a_receber: a.a_receber + parseFloat(b.valor_total.a_receber),
                    a_mais: a.a_mais + parseFloat(b.valor_total.a_mais),
                }
            }, init);
        },
        valor_selecionado: function () { 
            let init = { total: 0, glosado: 0, recebido: 0, a_receber: 0, a_mais: 0 };

            return this.selecteds.reduce((a, b) => { 
                return { 
                    total: a.total + parseFloat(b.valor_total.total),
                    glosado: a.glosado + parseFloat(b.valor_total.glosado),
                    recebido: a.recebido + parseFloat(b.valor_total.recebido),
                    a_receber: a.a_receber + parseFloat(b.valor_total.a_receber),
                    a_mais: a.a_mais + parseFloat(b.valor_total.a_mais),
                }
            }, init);
        },

        dadosFormatados: function () { 
            return this.exibicao.map(fatura => { 
                return { 
                    status: fatura.ch_status,
                    data: this.getFormatDate (fatura.dt_emissao, 'DD/MM/YYYY'), 
                    vencimento: fatura.fatura_envio ? this.getFormatDate (fatura.fatura_envio.dt_vencimento, 'DD/MM/YYYY') : '', 
                    fatura: fatura.id_fatura, 
                    protocolo: fatura.fatura_envio ? fatura.fatura_envio.st_protocolo_entrega : '',
                    nf: fatura.fatura_envio ? fatura.fatura_envio.st_nota_fiscal : '', 
                    operadora: fatura.operadora.st_operadora, 
                    envio: fatura.fatura_envio ? this.$util.getFormatDate(fatura.fatura_envio.dt_envio) : '', 
                    valor: this.$util.formatMoeda(fatura.valor_total.total),
                    glosado: this.$util.formatMoeda(fatura.valor_total.glosado),
                    recebido: this.$util.formatMoeda(fatura.valor_total.recebido),
                    a_receber: this.$util.formatMoeda(fatura.valor_total.a_receber),
                    a_mais: this.$util.formatMoeda(fatura.valor_total.a_mais),
                    status_fluxo: ( ( fatura.status_contato && fatura.status_contato.contato_status ) ? fatura.status_contato.contato_status.st_contato_status : '' ),
                };
            });
        }

    },

    methods: { 

        enviar_email () { 
            this.$refs.envio_email.abrir(this.selecteds, true);
        },

        lista_contratos (fatura) { 
            return fatura.contratos.map(item => item.st_descricao_arquivo_contrato)
                .join(', ');
        },

        paginar (page) {
            this.page = page;
            this.load(false);
        },

        filtrar (texto) { 
            $('[data-toggle="tooltip"]').tooltip('dispose');

            let filtro = '"' + texto + '"';
            this.pesquisar = this.pesquisar == filtro ? '' : filtro;
        },

        receber_faturas () { 
            this.dt_retorno = this.$util.hoje();
            $('#dtMovModal').modal('show');
        },

        salvar_receber_faturas () { 

            this.$util.atualizar(this, { 
                service: 'faturas', 
                func: 'receber_faturas', 
                redir_api: true, 
                dados: { 
                    faturas: this.selecteds.map(item => { 
                        return { 
                            id_fatura: item.id_fatura, 
                        };
                    }),
                    dt_retorno: this.dt_retorno,
                },
                reload: true,
                toast: true,
                modal: 'dtMovModal',
            });

        },

        ajustar_fim() { 
            if ( this.filtros.inicio )
                this.filtros.fim = this.filtros.inicio;
        },

        abrir_cancelar_faturas() { 
            this.validate = false;
            this.motivo_cancelamento = "";
            $('#cancelarFaturasModal').modal('show');
        },

        cancelar_faturas() { 

            this.$util.atualizar(this, { 
                service: 'faturas', 
                func: 'cancelar_faturas', 
                redir_api: true, 
                dados: { 
                    faturas: this.selecteds,
                    st_motivo: this.motivo_cancelamento, 
                },
                reload: true,
                toast: true,
                modal: 'cancelarFaturasModal'
            });

        },

        mesclar_faturas() { 
            if ( !confirm('Confirma mesclar as faturas selecionadas?') ) 
                return;

            this.$util.atualizar(this, { 
                service: 'faturas', 
                func: 'mesclar', 
                redir_api: true, 
                dados: { 
                    faturas: this.selecteds
                },
                reload: true,
                toast: true,
            });
        },

        fecharFatura () { 
            this.fatura = null;
            this.$router.replace({ name: 'faturas' });
            this.$store.commit('setBreadcrumb', this.breadcrumb ());
        },

        onSelectAll () { 
            let selected = this.selectAll;
            _.forEach(this.exibicao, element => {
                    element.selected = selected;
                });
        },
        format (n) { 
            let formatter = new Intl.NumberFormat('pt-Br', {
                style: 'currency',
                currency: 'BRL',
            });

            return formatter.format(n);
        },
        getFormatDate (date, format) { 
            return moment(date, 'YYYY-MM-DD').format(format);
        },
        desabilitar (botao) { 
            if ( botao == 'cancelar' ) { 
                return this.selecteds.findIndex(item => { 
                        return item.ch_status != 'FA';
                    }) >= 0;
            } else if ( botao == 'receber' ) { 
                return this.selecteds.findIndex(item => { 
                        return item.ch_status != 'FE';
                    }) >= 0;
            } else if ( botao == 'mesclar' ) { 
                return this.operadora_selected.length != 1 || this.selecteds.length <= 1 || 
                    this.selecteds.findIndex(item => { 
                        return item.ch_status != 'FA';
                    }) >= 0;
            } else if ( botao == 'mail' ) { 
                return this.selecteds.findIndex(item => { 
                        return item.ch_status != 'FA';
                    }) >= 0;
            }
        },
        load(showSpinner = true, page = null) { 

            if ( page )
                this.page = page;

            this.$store.commit('loading', true);

           if ( showSpinner )
                this.faturas = null;

            let query = { q: [ 
                { 
                    name: 'faturas.index', 
                    id: 'faturas', 
                    parms: { 
                        paralista: true, 
                        ...this.filtros, 
                        search: this.pesquisar,
                        size: 250, 
                    },
                    page: this.page
                } 
            ]};

            if ( this.canceltoken ) {
                this.canceltoken.cancel('#BC#');
            }

            this.canceltoken = this.axios.CancelToken.source();
                                    
            this.axios.post('/aql?a=faturas.index&page=' + this.page, query, {
                    cancelToken: this.canceltoken.token
                })
                .then(res => { 
                    if ( !res.data )
                        return;
                        
                    if ( res.data.faturas.status == 200 ) { 
                        this.faturas = res.data.faturas.data;
                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);

                    this.$util.setCookie('faturas-filtros-referencia', this.filtros.referencia);
                    this.$util.setCookie('faturas-filtros-tipo', this.filtros.tipo);
                    this.$util.setCookie('faturas-filtros-tipo-contrato', this.filtros.tipo_contrato);
                    this.$util.setCookie('faturas-filtros-status', this.filtros.status);

                    this.firstLoad = true;
                });
        },

        exibirFatura (fatura) { 
            this.fatura = fatura;

            this.$nextTick(() => { 
                this.$refs.fatura_page.abrirFatura(fatura);
                this.$router.replace({ name: 'fatura', params: { id_fatura: fatura.id_fatura }});
                this.$store.commit('setBreadcrumb', this.breadcrumb ());
            });
        },

        breadcrumb () { 

            let base = [
                { name: "Faturamento", path: "/faturamento/visao"},
                { name: "Faturas", path: "/faturamento/faturas"}
            ];

            if ( this.fatura ) { 
                base.push({ name: this.fatura.id_fatura, path: '/faturamento/faturas/' + this.fatura.id_fatura });
            }

            return base;

        },

        verificarBoletoBancoBrasil() {
            this.$util.load(this, {
                service: 'banco_brasil_helper',
                func: 'verificar_geracao_boleto_banco_brasil',
                loadTo: res => {
                    if (res) {
                        this.podeEnviarBoleto = true;
                    }
                }
            });
        },

        enviar_boletos() {
            if (this.selecteds.length == 0) {
                this.$toast.add({
                    severity: "warn",
                    summary: "Selecione",
                    detail: "Necessário selecionar as faturas para enviar os boletos por email",
                    life: 6000
                });

            }
            const id_faturas = this.selecteds.map((select) => select.id_fatura);
            
            this.$util.load(this, {
                service: 'banco_brasil_helper',
                func: 'enviar_boletos_em_lote',
                parms: {
                    id_faturas: id_faturas,
                },
                loadTo: res => {
                    if (res && res.status_code == 200) {
                        this.$toast.add({
                        severity: "success",
                        summary: "Enviados",
                        detail: res.msg,
                        life: 6000
                    });
                    }
                }
            });
        }

    },

    beforeMount () { 
        if ( !this.origem ) { 
            this.filtros.inicio = ""; moment().subtract(30, "days").format('YYYY-MM-DD');
            this.filtros.fim = ""; //moment().format('YYYY-MM-DD');
            this.filtros.periodo = "m";
        } else { 
            this.filtros.inicio = '2000-01-01';
            this.filtros.fim = moment().format('YYYY-MM-DD');
            this.filtros.periodo = "";
        }

        if ( this.id_operadora ) { 
            this.filtros.id_operadora = this.id_operadora;
        }
    },

    mounted () { 

        this.$store.commit('setBreadcrumb', this.breadcrumb ());

        // this.load ();

        if ( this.id_fatura ) { 
            this.exibirFatura({ id_fatura: this.id_fatura });
        }

        this.verificarBoletoBancoBrasil()

    },
    updated() {
        $('[data-toggle="tooltip"]').tooltip();
    },
}
</script>
